<template>

    <div class="page">
        <div class="page-shell">
            <div class="header-row">
                <div class="page-title">卫生专业技术资格考试</div>
                <div class="system-name">益题库 机考系统</div>
            </div>

            <div class="content-grid">
                <div class="left-column">
                    <div class="seat-card">

                    </div>

                    <div class="guide-card">
                        <div class="guide-title">一、所有按键均可使用鼠标操作</div>
                        <div class="guide-title">二、考试过程中需要用到的按键</div>

                        <div class="guide-item">
                            <span class="guide-index">1、</span>
                            <span class="guide-span">按字母</span>
                            <span class="guide-accent red">A-Z</span>
                            <span class="guide-span">选择相应答案，重新按相应键会删除原来选择的答案。</span>
                        </div>

                        <div class="guide-item compact">
                            <span class="guide-index">2、</span>
                            <span class="guide-accent red">→</span>
                            <span class="guide-span">进入下一题，</span>
                            <span class="guide-accent red">←</span>
                            <span class="guide-span">进入上一题，</span>
                            <span class="guide-accent red">2</span>
                            <span class="guide-span">调出计算器，</span>
                            <span class="guide-accent green">3</span>
                            <span class="guide-span">查看帮助，</span>
                            <span class="guide-accent red">4</span>
                            <span class="guide-span">交卷。</span>
                        </div>

                        <div class="guide-item">
                            <span class="guide-index">3、</span>
                            <span class="guide-span">答题过程中可以通过点击“帮助”按钮查看该操作说明，并可以查看各题型说明。</span>
                        </div>
                    </div>
                </div>

                <div class="user-card">
                    <div class="user-top">
                        <div class="user-info">
                            <div v-for="(item, index) in userInfo" :key="index" class="info-row">
                                <span class="info-label">{{ item.label }}</span>
                                <span class="info-value">{{ item.value }}</span>
                            </div>
                        </div>

                        <div class="avatar-box">
                            <img src="https://www.yitku.com//new_app/exam/yw_05.png" />
                        </div>
                    </div>

                    <div class="action-row">
                        <div class="action-btn relogin-btn" @click="goLogin">
                            <img src="https://www.yitku.com//new_app/exam/yw_03.png" />
                        </div>

                        <div class="action-btn" @click="goPapers">
                            <img src="https://www.yitku.com//new_app/exam/yw_04.png" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import LoginBox from "@/components/LoginBox";

export default {
    components: {
        LoginBox,
    },
    data() {
        return {
            id: 0,
            showLogin: false,
            mecoId: sessionStorage.getItem("access-subject_id"),
            userInfo: [
                { label: '姓    名：', value: '测试考生' },
                { label: '性    别：', value: '男' },
                { label: '准考证号：', value: '1001' },
                { label: '报考专业：', value: '测试专业' },
                { label: '报考级别：', value: '测试级别' },
                { label: '证件类型：', value: '身份证' },
                { label: '当前场次：', value: '00' },
                { label: '证件编号：', value: '1011010002106' },
                { label: '所在试室：', value: '第一试室' },
                { label: '所在考场：', value: '北京大学医学部' },
                { label: '所在单位：', value: '测试单位' }
            ]
        };
    },
    mounted: function () {
        var query = this.$route.query;
        if (query.paper_id) {
            this.id = query.paper_id;
        }
    },
    methods: {
        //判断是否登录
        IsUsersLogin() {
            let token = sessionStorage.getItem("access-token");
            console.log(token);
            if (token) {
                return true;
            } else {
                this.showLogin = true;
                this.$refs.login.getMiQrCode();
                return false;
            }
        },


        goPapers() {
            const loading = this.$loading({
                lock: true,
                text: '加载中……',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            let that = this;
            let formData = {};
            formData.subject_id = that.mecoId;
            formData.paper_id = that.id;
            that.axios.post("/getPaperMeco", formData).then((res) => {
                if (res) {
                    that.pc = res.data.pc;
                    that.pc_id = res.data.pc_id;
                    sessionStorage.setItem("access-mecoPapers", JSON.stringify(res.data));
                    setTimeout(() => {
                        loading.close();
                        this.$router.push("/meco/yiwei/papers");
                    }, 3000);
                }
            });
        },

        goLogin() {
            this.$router.push({
                path: "/meco/yiwei/login",
                query: {
                    paper_id: this.id,
                },
            });
        },


        closeBox(e) {
            this.showLogin = false;
        },
    }
}
</script>
<style scoped>
page {
    min-height: 100%;
    background: linear-gradient(180deg, #2b8fd4 0%, #1f79c7 50%, #1461ab 100%);
    font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
}

.page {
    min-height: 100vh;
    padding: 28px 24px 20px;
    box-sizing: border-box;
    background:
        radial-gradient(circle at top left, rgba(255, 255, 255, 0.12) 0, rgba(255, 255, 255, 0) 30%),
        linear-gradient(180deg, #2b8fd4 0%, #1f79c7 50%, #1461ab 100%);
}

.page-shell {
    max-width: 1280px;
    margin: 0 auto;
}

.header-row {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    padding: 0 4px;
    margin: 25px 0;
}

.page-title {
    font-size: 50px;
    line-height: 1.66;
    font-weight: 800;
    color: #e2f0ff;
    letter-spacing: 10px;
    padding-left: 145px;
    padding-bottom: 30px;
}

.system-name {
    padding-bottom: 8px;
    font-size: 20px;
    color: rgba(238, 248, 255, 0.96);
    letter-spacing: 2px;
}

.content-grid {
    margin-top: 22px;
    display: grid;
    grid-template-columns: 0.78fr 1.2fr;
    gap: 16px;
    align-items: start;
}

.left-column {
    display: grid;
    gap: 8px;
}

.seat-card,
.guide-card,
.user-card {
    border-radius: 16px;
    border: 1px solid rgba(255, 255, 255, 0.35);
    box-shadow: 0 18px 36px rgba(9, 56, 103, 0.15);
    box-sizing: border-box;
}

.seat-card {
    min-height: 328px;
    background: url("https://www.yitku.com//new_app/exam/yw_06.png") no-repeat center center;
    background-size: contain;
}

.seat-label {
    position: relative;
    font-size: 18px;
    color: rgba(255, 255, 255, 0.96);
}

.seat-number {
    position: relative;
    margin-top: 22px;
    span-align: center;
    font-size: 178px;
    line-height: 1;
    font-weight: 300;
    color: rgba(255, 255, 255, 0.96);
}

.guide-card {
    padding: 16px 18px 20px;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.98) 0%, rgba(246, 249, 252, 0.97) 100%);
}

.guide-title {
    font-size: 18px;
    line-height: 1.55;
    font-weight: 700;
    color: #ff5e00;
}

.guide-item {
    margin-top: 10px;
    font-size: 16px;
    line-height: 1.8;
    color: #1464a0;
}

.guide-item.compact {
    line-height: 1.95;
}

.guide-index,
.guide-span,
.guide-accent {
    display: inline;
}

.guide-accent.red {
    color: #ff4f4f;
}

.guide-accent.green {
    color: #1f8b56;
}

.user-card {
    padding: 22px 24px 26px;
    min-height: 490px;
    background: linear-gradient(180deg, rgba(208, 231, 245, 0.98) 0%, rgba(199, 225, 241, 0.98) 100%);
}

.user-top {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 24px;
}

.user-info {
    flex: 1;
    padding-top: 2px;
}

.info-row {
    display: flex;
    align-items: baseline;
    font-size: 18px;
    line-height: 2.32;
    color: #005d96;
    margin-bottom: 4px;
}

.info-label {
    width: 110px;
    font-weight: 700;
    white-space: pre;
    flex-shrink: 0;
}

.info-value {
    margin-left: 6px;
    font-weight: 600;
}

.avatar-box {
    position: relative;
    width: 122px;
    height: 122px;
    flex-shrink: 0;
    background: linear-gradient(180deg, #cbcbcb 0%, #b7b7b7 100%);
    overflow: hidden;
}

.avatar-frame {
    position: absolute;
    inset: 0;
    border: 1px solid rgba(255, 255, 255, 0.44);
}

.avatar-head {
    position: absolute;
    left: 50%;
    top: 16px;
    width: 52px;
    height: 52px;
    margin-left: -26px;
    background: #555555;
    border-radius: 50%;
}

.avatar-body {
    position: absolute;
    left: 50%;
    bottom: 0;
    width: 104px;
    height: 60px;
    margin-left: -52px;
    background: #555555;
    border-radius: 54px 54px 0 0;
}

.avatar-question {
    position: absolute;
    left: 50%;
    top: 10px;
    transform: translateX(-50%);
    font-size: 92px;
    line-height: 1;
    font-weight: 700;
    color: #ffffff;
}

.action-row {
    margin-top: 24px;
    display: flex;
    gap: 32px;
    justify-content: center;
}

.action-btn {
    height: 58px;
    min-width: 168px;
    padding: 0 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-weight: 700;
    color: #ffffff;
    box-sizing: border-box;
    cursor: pointer;
}

.start-btn {
    background: linear-gradient(180deg, #2eb9ef 0%, #1894cb 100%);
}

.btn-icon {
    position: relative;
    margin-right: 10px;
    flex-shrink: 0;
}

.arrow-icon {
    width: 30px;
    height: 30px;
}

.arrow-head {
    position: absolute;
    left: 0;
    top: 7px;
    width: 14px;
    height: 14px;
    border-left: 4px solid #6bd100;
    border-bottom: 4px solid #6bd100;
    transform: rotate(45deg);
}

.arrow-tail {
    position: absolute;
    left: 10px;
    top: 12px;
    width: 16px;
    height: 6px;
    background: #6bd100;
    border-radius: 999px;
}

.start-icon {
    width: 26px;
    height: 26px;
    border-radius: 50%;
    background: radial-gradient(circle, #befe7e 0%, #71ea0b 54%, #2eb400 100%);
    border: 2px solid rgba(255, 255, 255, 0.75);
    box-shadow: 0 0 12px rgba(79, 224, 0, 0.5);
}

@media screen and (max-width: 1180px) {
    .page-title {
        font-size: 48px;
    }

    .content-grid {
        grid-template-columns: 0.88fr 1.12fr;
    }
}

@media screen and (max-width: 960px) {
    .page {
        padding-left: 16px;
        padding-right: 16px;
    }

    .header-row {
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
    }

    .page-title {
        font-size: 38px;
    }

    .system-name {
        padding-bottom: 0;
    }

    .content-grid {
        grid-template-columns: 1fr;
    }

    .user-top {
        flex-direction: column;
    }

    .avatar-box {
        align-self: center;
    }

    .action-row {
        flex-direction: column;
        gap: 14px;
    }

    .action-btn {
        width: 100%;
    }

    .seat-number {
        font-size: 136px;
    }

    .user-card {
        min-height: auto;
    }
}
</style>